/**************************************************
 * Nombre:       FechaContacto
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {theme} from "../../../../Tema";
import dayjs from "dayjs";


const FechaContacto = ({nombre, fecha, proximo = false}) => {

    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                color: proximo && fecha < new Date().getTime() ? 'red' : theme.palette.info.main
            }}
        >

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography
                    sx={{fontSize: 10, lineHeight: 1.1, color: theme.palette.info.main + 90}}>{nombre}</Typography>
            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                <Typography
                    sx={{fontSize: 13, lineHeight: 1.2}}>{fecha && dayjs(fecha).format('DD/MM - HH:mm')}</Typography>
            </Grid>

        </Grid>
    )

}
export default FechaContacto